import { render, staticRenderFns } from "./ChooseProfile.vue?vue&type=template&id=ab64bda8&"
import script from "./ChooseProfile.vue?vue&type=script&lang=js&"
export * from "./ChooseProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChooseProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports